"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accessor_1 = require("./Accessor");
exports.throwIfUndefined = Accessor_1.throwIfUndefined;
exports.undefinedToNull = Accessor_1.undefinedToNull;
exports.undefinedToZero = Accessor_1.undefinedToZero;
exports.extractDatumFromVictoryRow = Accessor_1.extractDatumFromVictoryRow;
// This is a numeric enum because of some specific unique circumstances (the
// roles function as indices into an array of values in some code, sorta like a
// dictionary but a bit different), and it was created before the tslint rule.
// Probably we should convert to a string enum.
// tslint:disable-next-line:prefer-string-enums
var MetricValueRole;
(function (MetricValueRole) {
    MetricValueRole[MetricValueRole["CURRENT"] = 0] = "CURRENT";
    MetricValueRole[MetricValueRole["ABSOLUTE_CHANGE"] = 1] = "ABSOLUTE_CHANGE";
    MetricValueRole[MetricValueRole["PERCENTAGE_CHANGE"] = 2] = "PERCENTAGE_CHANGE";
})(MetricValueRole = exports.MetricValueRole || (exports.MetricValueRole = {}));
exports.getDataRowFromDataPoint = function (dataPoint) {
    var _a, _b;
    return {
        measure: dataPoint.measure,
        timestamp: dataPoint.timestamp,
        comparisonMeasure: (_a = dataPoint.comparison) === null || _a === void 0 ? void 0 : _a.measure,
        comparisonTimestamp: (_b = dataPoint.comparison) === null || _b === void 0 ? void 0 : _b.timestamp,
    };
};
// These values need to match the values returned from the Edge Service.
// See 'DateGranularity' in the Edge Service:
// tslint:disable-next-line: max-line-length
// https://gitlab.tableausoftware.com/metrics/service/edge/metrics-edge-service/blob/master/src/main/kotlin/com/tableau/metrics/edge/grpc/p4/json/MetricDataPoints.kt
var DateTrunc;
(function (DateTrunc) {
    DateTrunc["YEAR"] = "year";
    DateTrunc["QUARTER"] = "quarter";
    DateTrunc["MONTH"] = "month";
    DateTrunc["DAY"] = "day";
    DateTrunc["HOUR"] = "hour";
    DateTrunc["MINUTE"] = "minute";
    DateTrunc["SECOND"] = "second";
    DateTrunc["WEEK"] = "week";
    DateTrunc["ISO_YEAR"] = "iso-year";
    DateTrunc["ISO_QTR"] = "iso-quarter";
    DateTrunc["ISO_WEEK"] = "iso-week";
    DateTrunc["ISO_WEEKDAY"] = "iso-weekday";
    DateTrunc["UNKNOWN"] = "unknown";
    DateTrunc["NONE"] = "none";
})(DateTrunc = exports.DateTrunc || (exports.DateTrunc = {}));
/// From VPC
var DateGranularity;
(function (DateGranularity) {
    DateGranularity["UNKNOWN"] = "unknown";
    DateGranularity["SECOND"] = "second";
    DateGranularity["MINUTE"] = "minute";
    DateGranularity["HOUR"] = "hour";
    DateGranularity["DAY"] = "day";
    DateGranularity["WEEK"] = "week";
    DateGranularity["MONTH"] = "month";
    DateGranularity["QUARTER"] = "quarter";
    DateGranularity["YEAR"] = "year";
    DateGranularity["ISO_YEAR"] = "iso-year";
    DateGranularity["ISO_QUARTER"] = "iso-quarter";
    DateGranularity["ISO_WEEK"] = "iso-week";
    DateGranularity["ISO_WEEKDAY"] = "iso-weekday";
})(DateGranularity = exports.DateGranularity || (exports.DateGranularity = {}));
exports.dateTruncFromGranularity = function (date) {
    switch (date) {
        case DateGranularity.SECOND: {
            return DateTrunc.SECOND;
        }
        case DateGranularity.MINUTE: {
            return DateTrunc.MINUTE;
        }
        case DateGranularity.HOUR: {
            return DateTrunc.HOUR;
        }
        case DateGranularity.DAY: {
            return DateTrunc.DAY;
        }
        case DateGranularity.ISO_WEEKDAY: {
            return DateTrunc.ISO_WEEKDAY;
        }
        case DateGranularity.WEEK: {
            return DateTrunc.WEEK;
        }
        case DateGranularity.ISO_WEEK: {
            return DateTrunc.ISO_WEEK;
        }
        case DateGranularity.MONTH: {
            return DateTrunc.MONTH;
        }
        case DateGranularity.QUARTER: {
            return DateTrunc.QUARTER;
        }
        case DateGranularity.ISO_QUARTER: {
            return DateTrunc.ISO_QTR;
        }
        case DateGranularity.YEAR: {
            return DateTrunc.YEAR;
        }
        case DateGranularity.ISO_YEAR: {
            return DateTrunc.ISO_YEAR;
        }
        case DateGranularity.UNKNOWN:
        case undefined:
        default: {
            return DateTrunc.UNKNOWN;
        }
    }
};
exports.dateGranularityFromTrunc = function (dateTrunc) {
    switch (dateTrunc) {
        case DateTrunc.SECOND: {
            return DateGranularity.SECOND;
        }
        case DateTrunc.MINUTE: {
            return DateGranularity.MINUTE;
        }
        case DateTrunc.HOUR: {
            return DateGranularity.HOUR;
        }
        case DateTrunc.DAY: {
            return DateGranularity.DAY;
        }
        case DateTrunc.ISO_WEEKDAY: {
            return DateGranularity.ISO_WEEKDAY;
        }
        case DateTrunc.WEEK: {
            return DateGranularity.WEEK;
        }
        case DateTrunc.ISO_WEEK: {
            return DateGranularity.ISO_WEEK;
        }
        case DateTrunc.MONTH: {
            return DateGranularity.MONTH;
        }
        case DateTrunc.QUARTER: {
            return DateGranularity.QUARTER;
        }
        case DateTrunc.ISO_QTR: {
            return DateGranularity.ISO_QUARTER;
        }
        case DateTrunc.YEAR: {
            return DateGranularity.YEAR;
        }
        case DateTrunc.ISO_YEAR: {
            return DateGranularity.ISO_YEAR;
        }
        case DateTrunc.UNKNOWN:
        case DateTrunc.NONE:
        case undefined:
        default: {
            return DateGranularity.UNKNOWN;
        }
    }
};
exports.detailTypes = [
    MetricValueRole.ABSOLUTE_CHANGE,
    MetricValueRole.PERCENTAGE_CHANGE,
];
exports.listTypes = [
    MetricValueRole.CURRENT,
    MetricValueRole.ABSOLUTE_CHANGE,
    MetricValueRole.PERCENTAGE_CHANGE,
];
var FiscalYearStartMonth;
(function (FiscalYearStartMonth) {
    FiscalYearStartMonth[FiscalYearStartMonth["JANUARY"] = 1] = "JANUARY";
    FiscalYearStartMonth[FiscalYearStartMonth["FEBRUARY"] = 2] = "FEBRUARY";
    FiscalYearStartMonth[FiscalYearStartMonth["MARCH"] = 3] = "MARCH";
    FiscalYearStartMonth[FiscalYearStartMonth["APRIL"] = 4] = "APRIL";
    FiscalYearStartMonth[FiscalYearStartMonth["MAY"] = 5] = "MAY";
    FiscalYearStartMonth[FiscalYearStartMonth["JUNE"] = 6] = "JUNE";
    FiscalYearStartMonth[FiscalYearStartMonth["JULY"] = 7] = "JULY";
    FiscalYearStartMonth[FiscalYearStartMonth["AUGUST"] = 8] = "AUGUST";
    FiscalYearStartMonth[FiscalYearStartMonth["SEPTEMBER"] = 9] = "SEPTEMBER";
    FiscalYearStartMonth[FiscalYearStartMonth["OCTOBER"] = 10] = "OCTOBER";
    FiscalYearStartMonth[FiscalYearStartMonth["NOVEMBER"] = 11] = "NOVEMBER";
    FiscalYearStartMonth[FiscalYearStartMonth["DECEMBER"] = 12] = "DECEMBER";
})(FiscalYearStartMonth = exports.FiscalYearStartMonth || (exports.FiscalYearStartMonth = {}));
//# sourceMappingURL=index.js.map